import { Info } from "@icons";
import classNames from "classnames";
import { ReactNode } from "react";

interface LabelProps {
  name: string;
  label: string | JSX.Element;
  info?: string | ReactNode;
  required?: boolean;
  error?: string;
  setDisplayInfo: React.Dispatch<React.SetStateAction<boolean>>;
  labelActions?: ReactNode;
}

export default function Label({
  name,
  label,
  info,
  required = false,
  error,
  setDisplayInfo,
  labelActions,
}: LabelProps) {
  return (
    <div className="flex gap-2 items-center">
      <label
        htmlFor={name}
        className={classNames(
          "text-gray-900 font-comfortaa",
          "text-base font-light capitalize",
          {
            "text-red-500": !!error,
          },
        )}
      >
        {label}
        <span>{required ? "*" : ""}</span>
      </label>
      {!!info && (
        <button
          type="button"
          className="text-gray-500 hover:text-gray-700 rounded-full focus:bg-primary-50 border-0 leading-none flex items-center justify-center"
          onClick={() => setDisplayInfo((prev) => !prev)}
        >
          <Info size={16} />
        </button>
      )}
      {labelActions && (
        <div className="flex items-center gap-3 ml-auto">{labelActions}</div>
      )}
    </div>
  );
}
